
import { cloneDeep } from '@/lib';
import { Col, Radio, Row } from 'ant-design-vue';
import {
  defineComponent, inject, ref, toRaw,
} from 'vue';

export default defineComponent({
  components: {
    aRow: Row,
    aCol: Col,
    aRadio: Radio,
    aRadioGroup: Radio.Group,
  },
  props: {
    /** 所有选项 */
    pMetas: {
      type: Array,
      default: () => ([]),
    },
    /** 正确选项 */
    pAnswer: {
      type: Boolean,
      default: () => true,
    },
    /** 学生答案 */
    stuAnswer: {
      type: Boolean,
      required: false,
    },
  },
  emits: ['onStuAnswer'],
  setup(props, { emit }) {
    const jobView = inject('jobView');
    const question = ref<boolean>(!!props.pAnswer);
    // 学生做题
    const stuData = () => {
      if (props.stuAnswer === undefined) return undefined;
      return !!props.stuAnswer;
    };
    const todoStu = ref(stuData());
    // console.log(props.stuAnswer, 'stuAnswer');
    const todoSave = () => {
      emit('onStuAnswer', [cloneDeep(toRaw(!!todoStu.value))]);
    };
    return {
      jobView,
      question,
      todoStu,
      // saveStuAnswer,
      todoSave,
    };
  },
});
